"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegExecutionType = void 0;
var LegExecutionType;
(function (LegExecutionType) {
    LegExecutionType["FCL"] = "FCL";
    LegExecutionType["DRAYAGE"] = "DRAYAGE";
    LegExecutionType["FTL"] = "FTL";
    LegExecutionType["LTL"] = "LTL";
    LegExecutionType["METRO_P_D"] = "METRO_P_D";
    LegExecutionType["MIDDLE_MILE"] = "MIDDLE_MILE";
    LegExecutionType["PARTIAL_FTL"] = "PARTIAL_FTL";
    LegExecutionType["TRANSLOAD"] = "TRANSLOAD";
    LegExecutionType["UNTENDERED_LTL"] = "UNTENDERED_LTL";
})(LegExecutionType = exports.LegExecutionType || (exports.LegExecutionType = {}));
//# sourceMappingURL=FreightRequest.js.map